import { Fragment, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Error, Label } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useSenderDetailsContext } from 'pages/settings/pages/rcsV2/pages/SenderDetails/hooks/useSenderDetailsContext'

export const BrandTermsSection: FC = observer(() => {
  const {
    brandTermsStore: {
      privacyPolicyUrl,
      setPrivacyPolicyUrl,
      privacyPolicyError,
      termsAndConditionsUrl,
      setTermsAndConditionsUrl,
      termsAndConditionsError,
    },
  } = useSenderDetailsContext()

  return (
    <Fragment>
      <Box display={'grid'} gap={'4px'} mb={'20px'} mt={'35px'}>
        <Label
          label={{
            text: 'Privacy policy URL',
            textColor: 'var(--content-primary-primary)',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={privacyPolicyError}
          InputProps={{
            placeholder: 'https://',
          }}
          value={privacyPolicyUrl}
          onChange={setPrivacyPolicyUrl}
        />
        <Error type='text' error={privacyPolicyError} />
      </Box>
      <Box display={'grid'} gap={'4px'} mb={'40px'}>
        <Label
          label={{
            textColor: 'var(--content-primary-primary)',
            text: 'Terms and conditions URL',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={termsAndConditionsError}
          InputProps={{
            placeholder: 'https://',
          }}
          value={termsAndConditionsUrl}
          onChange={setTermsAndConditionsUrl}
        />
        <Error type='text' error={termsAndConditionsError} />
      </Box>
    </Fragment>
  )
})
